import { type InputCapture } from '@canvas/input';

import { type SelectionsMachine } from '../../machine/selection-machine';
import { type SharedEventLoop } from '../event-loop';
import { type SelectionInput } from '../types';

import { createMouseStateMachine } from './state-machine/mouse-state-machine';
import { getClickTarget } from './utils/get-click-target';

export function createMouseInput(
  machine: SelectionsMachine,
  inputCapture: InputCapture,
  sharedLoop: SharedEventLoop
): SelectionInput {
  let currentState = createMouseStateMachine(machine, inputCapture, getClickTarget);
  let unsubscribe: () => void;

  return {
    setup() {
      unsubscribe = sharedLoop.subscribe((events) => {
        // Only process the pointer events we care about
        for (const event of events) {
          if (event.type === 'pointerDown') {
            currentState = currentState.onPointerDown(event);
          } else if (event.type === 'pointerMove') {
            currentState = currentState.onPointerMove(event);
          } else if (event.type === 'pointerUp') {
            currentState = currentState.onPointerUp(event);
          }
        }
      });
    },

    dispose() {
      unsubscribe?.();
    },
  };
}
